enum DenormalizeDirections {
    Up = 'up',
    Down = 'down',
}

type GoToFrameType = (
    frameIndex: number,
    options?: {
        animationTime?: number;
        onReachFrame?: () => void;
    },
) => void;

export { DenormalizeDirections };
export type { GoToFrameType };
